<template>
  <div class="container login-page pt-5">

    <h1 class="text-center mb-5">TecknaEl Partner Kontrollpanel</h1>

    <login-preview :handle="$router.currentRoute.params.company"></login-preview>

    <div class="row">
      <div class="col-sm-3 hidden"></div>
      <div class="col-12 col-sm-6">
        <div class="card card-login">
          <div class="card-body">

            <div class="mb-5">
              <small>
                Var god uppge ert företags lösenord för att kunna logga in på vår partnerportal. Om ni inte är säkra på ert lösenord eller har glömt det, vänligen kontakta oss på <a href="mailto:hej@tecknael.se">partner@tecknael.se</a> så återkopplar vi med ett nytt lösenord.
              </small>
            </div>

            <div class="alert alert-danger" v-if="failed">
              Det angivna lösenordet är felaktigt
            </div>

            <div class="form-group">
              <input type="password" class="form-control" placeholder="Lösenord" v-model="password">
            </div>

            <div class="form-group text-center">
              <button type="button" class="btn btn-primary btn-sm" @click="login">
                <font-awesome-icon icon="sign-in-alt" />
                Logga in
              </button>
            </div>

          </div>
        </div>
      </div>
      <div class="col-sm-3 hidden"></div>
    </div>

    <powered-by></powered-by>

  </div>
</template>

<script>

  import Vue from 'vue'
  import {mapState} from 'vuex'
  import LoginPreview from "./Partials/LoginPreview"
  import PoweredBy from "../Partials/PoweredBy"

  export default {
    name: "Index",
    components: {PoweredBy, LoginPreview},
    computed: {
      ...mapState({
        failed: state => state.auth.failed,
        company: state => state.auth.company,
      })
    },
    methods: {
      async login(){
        this.showLoader()

        await this.$store.dispatch('loginWithPassword', {
          handle: this.$router.currentRoute.params.company,
          password: this.password
        })

        if(this.company.handle !== null){

          this.$cookies.set('authToken', this.company.partner_token, '2h')

          this.$router.push({name: 'dashboard'})
        }

        this.hideLoader()
      }
    },
    data(){
      return {
        password: null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Auth/Login.vue